import { Overlay, OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, inject, Input, signal, TemplateRef, viewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import { ModalCounselingReservationDialogComponent } from 'src/app/components/modal-counseling-reservation/modal-counseling-reservation-dialog/modal-counseling-reservation-dialog.component';

@Component({
  selector: 'app-modal-counseling-reservation',
  imports: [
    OverlayModule
  ],
  templateUrl: './modal-counseling-reservation.component.html',
  styleUrl: './modal-counseling-reservation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalCounselingReservationComponent {
  readonly #viewContainerRef = inject(ViewContainerRef);
  readonly #http = inject(HttpClient);
  readonly #cdkOverlay = inject(Overlay);
  readonly #dialog = inject(MatDialog);

  @Input() buttunText: string | null = null;
  @Input() topText: string | null = null;

  readonly #closeDialog = signal(false);
  readonly #value = signal(null);

  readonly #overlayRef = signal<OverlayRef | null>(null);

  readonly floatButton = viewChild.required(TemplateRef<any>);
  constructor() {
    const data = sessionStorage.getItem('shindan-form');
    if (!data) {
      return;
    }
    const value = JSON.parse(data);

    this.#value.set(value);
    timer(1000)
      .subscribe({
        next: () => {
          this.openModal();
        }
      });
  }

  openModal() {
    this.#closeDialog.set(false);
    if (this.#overlayRef()?.hasAttached) {
      this.#overlayRef()?.dispose();
      this.#overlayRef.set(null);
    }
    const ref = this.#dialog.open(ModalCounselingReservationDialogComponent, {
      data: { buttonText: this.buttunText, topText: this.topText, value: this.#value() },
      disableClose: true,
      maxWidth: '95dvw',
      maxHeight: '95dvh'
    });

    ref.afterClosed().subscribe({
      next: res => {
        this.#closeDialog.set(true);
        this.#openOverlay();
      }
    });
  }

  #openOverlay() {
    const overlayRef = this.#cdkOverlay.create({
      hasBackdrop: false,
      positionStrategy: this.#cdkOverlay
        .position()
        .global()
        .right('2.8rem')
        .bottom('3rem')
    });
    overlayRef.attach(new TemplatePortal(this.floatButton(), this.#viewContainerRef));
    this.#overlayRef.set(overlayRef);
  }
}
